import {EventEmitter, Injectable} from '@angular/core';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MatSort} from '@angular/material/sort';

@Injectable()
export class GlobalService {

    public pageScrolledDown$: EventEmitter<any> = new EventEmitter();

    static setOrUpdateDataSourceData(context: any, source: any,
        paginatorVarName: string, sortVarName: string, dataSourceVarName: string, unsubscribe$: string) {
        if (context[dataSourceVarName]) {
            context[dataSourceVarName].data = source;
        } else {
            context[dataSourceVarName] = new MatTableDataSource(source);
            GlobalService.setTablePaginator(context, context[paginatorVarName], context[dataSourceVarName]);
            GlobalService.setTableSort(
                context, context[sortVarName], context[dataSourceVarName], context[unsubscribe$], context[paginatorVarName]);
        }
    }

    static setTablePaginator(context: any, paginator: MatPaginator, dataSource: MatTableDataSource<any>) {
        if (paginator) {
            dataSource.paginator = paginator;
        } else {
            setTimeout(() => {
                this.setTablePaginator(context, context.paginator, context.dataSource);
            }, 0);
        }
    }

    static setTableSort(context: any, sort: MatSort, dataSource: MatTableDataSource<any>, unsubscribe$: Subject<void>, paginator: MatPaginator) {
        if (sort) {
            dataSource.sort = sort;
            sort.sortChange.pipe(takeUntil(unsubscribe$)).subscribe(() => {
                if (paginator) {
                    paginator.firstPage();
                }
            });
        } else {
            setTimeout(() => {
                this.setTableSort(context, context.sort, context.dataSource, context.unsubscribe$, context.paginator);
            }, 0);
        }
    }

}
